import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { Container, Row, Col } from "react-grid-system";

const Datasheets = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "Datasheets", url: "/datasheets" },
            ]}
          />
          <h1>Datasheets</h1>
          <p>
            Datasheets, design files, and resources for building your own
            Notecarriers.
          </p>
        </Col>
      </Row>

      <hr />

      <h2>Hardware Resources</h2>
      <Row>
        <Col sm={6} lg={4}>
          <div className="middleGridCard">
            <div className="middleGridImg">
              <TrackedLink href="/datasheets/notecard-datasheet">
                <img
                  alt="Notecard Datasheet"
                  src={ImgSrc("/images/hardware/notecard.svg")}
                />
              </TrackedLink>
            </div>
            <div className="middleGridInfo">
              <h4>Notecard Datasheets</h4>
              <p>
                Technical details and specifications for the various Blues
                Notecard models.
              </p>
            </div>
            <div className="gridLinks">
              <h4>In this section</h4>
              <TrackedLink href="/datasheets/notecard-datasheet/note-wbglw">
                Notecard Cell+WiFi - Global
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-nbglw">
                Notecard Cell+WiFi (NB) - Global
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-nbgl-500">
                Notecard Cellular (NB) - Global
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-wbnaw">
                Notecard Cell+WiFi - N. America
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-nbnaw">
                Notecard Cell+WiFi (NB) - N. America
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-wbna-500">
                Notecard Cellular - N. America
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-nbna-500">
                Notecard Cellular (NB) - N. America
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-wbexw">
                Notecard Cell+WiFi - EMEA
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-wbex-500">
                Notecard Cellular - EMEA
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-wifi">
                Notecard WiFi v1
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-esp">
                Notecard WiFi v2
              </TrackedLink>
              <TrackedLink href="/datasheets/notecard-datasheet/note-lora">
                Notecard LoRa
              </TrackedLink>
            </div>
          </div>
        </Col>
        <Col sm={6} lg={4}>
          <div className="middleGridCard">
            <div className="middleGridImg">
              <TrackedLink href="/datasheets/notecarrier-datasheet/">
                <img
                  alt="Notecarrier Datasheet"
                  src={ImgSrc("/images/hardware/notecarrier.svg")}
                />
              </TrackedLink>
            </div>

            <div className="middleGridInfo">
              <h4>Notecarrier Datasheets</h4>
              <p>
                Technical details and specifications for Notecard carrier
                boards.
              </p>
            </div>

            <div className="gridLinks">
              <h4>In this section</h4>
              <TrackedLink href="/datasheets/notecarrier-datasheet/notecarrier-a">
                Notecarrier A
              </TrackedLink>
              <TrackedLink href="/datasheets/notecarrier-datasheet/notecarrier-b-v3-1">
                Notecarrier B
              </TrackedLink>
              <TrackedLink href="/datasheets/notecarrier-datasheet/notecarrier-f-v1-3">
                Notecarrier F
              </TrackedLink>
              <TrackedLink href="/datasheets/notecarrier-datasheet/notecarrier-pi-v2-0">
                Notecarrier Pi
              </TrackedLink>
              <TrackedLink href="/datasheets/notecarrier-datasheet/notecarrier-r-v1-0">
                Notecarrier R
              </TrackedLink>
            </div>
          </div>
        </Col>
        <Col md={6} lg={4}>
          <div className="middleGridCard">
            <div className="middleGridImg">
              <TrackedLink href="https://github.com/blues/note-hardware">
                <img
                  alt="Design Resources"
                  src={ImgSrc("/images/hardware/design.svg")}
                />
              </TrackedLink>
            </div>
            <div className="middleGridInfo">
              <h4>Design Resources</h4>
              <p>Design resources for the Blues Notecard and Notecarriers.</p>
            </div>
            <div className="gridLinks">
              <h4>Schematics, layouts, and models</h4>
              <TrackedLink href="https://github.com/blues/note-hardware/tree/master/Notecard">
                Notecard
              </TrackedLink>
              <TrackedLink href="https://github.com/blues/note-hardware/tree/master/Notecarrier-A">
                Notecarrier A
              </TrackedLink>
              <TrackedLink href="https://github.com/blues/note-hardware/tree/master/Notecarrier-B">
                Notecarrier B
              </TrackedLink>
              <TrackedLink href="https://github.com/blues/note-hardware/tree/master/Notecarrier-F">
                Notecarrier F
              </TrackedLink>
              <TrackedLink href="https://github.com/blues/note-hardware/tree/master/Notecarrier-Pi">
                Notecarrier Pi
              </TrackedLink>
              <TrackedLink href="https://github.com/blues/note-hardware/tree/master/Notecarrier-R">
                Notecarrier R
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <style jsx>{`
        .middleGridInfo,
        .gridLinks {
          padding-left: 0.5rem;
        }
        .middleGridCard {
          margin-top: 2rem;
        }

        .middleGridImg img {
          width: 100%;
          cursor: pointer;
        }

        .middleGridInfo h4 {
          margin-bottom: 0;
        }
      `}</style>
    </Container>
  </>
);

export default Datasheets;
